/* eslint-disable react-hooks/exhaustive-deps, array-bracket-newline */
import React, { useState } from 'react';
import { LS_NEW_PAIRS_KEY } from './NewPairsTable';

interface ITableWidths {
  pair: number;
  poolCreated: number;
  priceUSD: number;
  liquidity: number;
  volume: number;
  baseReserve: number;
  quoteReserve: number;
  contract: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  pair: 150,
  poolCreated: 130,
  priceUSD: 180,
  liquidity: 150,
  volume: 150,
  baseReserve: 130,
  quoteReserve: 130,
  contract: 150,
};

interface IUseTableDataProps {
  pairs: any;
}

const useNewPairsTableData = ({ pairs }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_NEW_PAIRS_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => pairs, [pairs]);
  const columns = React.useMemo(
    () => [
      {
        id: 'pair',
        Header: 'Pair',
        accessor: 'pair',
        disableSortBy: true,
        width: tableColumnsWidth['pair'] || tableWidthsDefaultState['pair'],
      },
      {
        id: 'pool_created',
        Header: 'Listed since',
        accessor: 'pool_created',
        width:
          tableColumnsWidth['poolCreated'] ||
          tableWidthsDefaultState['poolCreated'],
      },
      {
        id: 'priceUSD',
        Header: 'Token price USD',
        accessor: 'price_a_usd',
        disableSortBy: true,
        width:
          tableColumnsWidth['priceUSD'] || tableWidthsDefaultState['priceUSD'],
      },
      {
        id: 'liquidity',
        Header: 'Total liquidity',
        accessor: 'liquidity',
        width:
          tableColumnsWidth['liquidity'] ||
          tableWidthsDefaultState['liquidity'],
      },
      {
        id: 'volume',
        Header: '24H Volume',
        accessor: 'volume',
        width: tableColumnsWidth['volume'] || tableWidthsDefaultState['volume'],
      },
      {
        id: 'base_reserve',
        Header: 'Pool Base',
        accessor: 'base_reserve',
        disableSortBy: true,
        width:
          tableColumnsWidth['baseReserve'] ||
          tableWidthsDefaultState['baseReserve'],
      },
      {
        id: 'quote_reserve',
        Header: 'Pool quote',
        accessor: 'quote_reserve',
        disableSortBy: true,
        width:
          tableColumnsWidth['quoteReserve'] ||
          tableWidthsDefaultState['quoteReserve'],
      },
      {
        id: 'contract',
        Header: 'Contract',
        accessor: 'address',
        disableSortBy: true,
        width:
          tableColumnsWidth['contract'] || tableWidthsDefaultState['contract'],
      },
    ],
    []
  );

  return { columns, data, tableColumnsWidth };
};

export { useNewPairsTableData };
